export default "__VITE_ASSET__ChhfgMR2__"